import React from 'react';
import ShareComponent from './shareComponent';
import './style/urlContainer.css';

export default function UrlContainer({data, onSubmit = () => {}}) {

    return (
            <div className='wz-url-container'>
                <div className='wz-url-title'>{data.resale_option.label}</div>
                <div className='wz-url-description'>{data.resale_option.description}</div>
                <div className='wz-resale_link'>
                    <input className='wz-copy-to-clipboard-input'value={data.resale_option.url} disabled/>
                    <ShareComponent data={data} onSubmit={onSubmit}/>
                </div>
            </div>

        
    )
};
